import { gql } from '@apollo/client';

// 내 배송지 목록 조회
export const GET_MY_DELIVERY_ADDRESSES = gql`
  query GetMyDeliveryAddresses {
    getMyDeliveryAddresses {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`;

// 특정 배송지 조회
export const GET_DELIVERY_ADDRESS = gql`
  query GetDeliveryAddress($id: Int!) {
    getDeliveryAddress(id: $id) {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`;

// 기본 배송지 조회
export const GET_DEFAULT_DELIVERY_ADDRESS = gql`
  query GetDefaultDeliveryAddress {
    getDefaultDeliveryAddress {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`;

// 배송지 추가
export const CREATE_DELIVERY_ADDRESS = gql`
  mutation CreateDeliveryAddress($input: DeliveryAddressInput!) {
    createDeliveryAddress(input: $input) {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`;

// 배송지 수정
export const UPDATE_DELIVERY_ADDRESS = gql`
  mutation UpdateDeliveryAddress($id: Int!, $input: UpdateDeliveryAddressInput!) {
    updateDeliveryAddress(id: $id, input: $input) {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`;

// 배송지 삭제
export const DELETE_DELIVERY_ADDRESS = gql`
  mutation DeleteDeliveryAddress($id: Int!) {
    deleteDeliveryAddress(id: $id)
  }
`;

// 기본 배송지 설정
export const SET_DEFAULT_DELIVERY_ADDRESS = gql`
  mutation SetDefaultDeliveryAddress($id: Int!) {
    setDefaultDeliveryAddress(id: $id) {
      id
      name
      recipient
      phone
      zipCode
      address
      addressDetail
      isDefault
      createdAt
      updatedAt
    }
  }
`; 